module.exports = __webpack_public_path__ + "img/money-mouth.fd8058fd.svg";